import { Empty } from 'antd';
import React from 'react';
import styles from './Metocean.module.scss';
import { ISampleReport, ReportCard } from './ReportCard';
interface ReportsListProps {
  reports: ISampleReport[];
  onPdfDownload: (report: ISampleReport) => void;
  onExcelDownload: (report: ISampleReport) => void;
}

export const ReportsList: React.FC<ReportsListProps> = ({
  reports,
  onPdfDownload,
  onExcelDownload,
}) => {
  const areNoReportsAvailable = !reports.length;

  return (
    <div className={styles.metOceanReportsContainer}>
      {areNoReportsAvailable && (
        <div className={styles.emptyContent}>
          <Empty
            description={'No reports available'}
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        </div>
      )}
      {reports.map((report) => (
        <div key={report.id}>
          <ReportCard
            report={report}
            onPdfDownload={onPdfDownload}
            onExcelDownload={onExcelDownload}
          />
        </div>
      ))}
    </div>
  );
};
